import {Typography} from "@mui/material";

const AlertMessage = ({
  originName,
  destinationName,
}: {
  originName?: string | null;
  destinationName?: string | null;
}) => {
  return (
    <Typography variant="body2" color="text.secondary" component="span">
      Esta ação não pode ser revertida. Você irá apagar a viagem de origem
      <Typography component="span" sx={{fontWeight: 600}}>
        {" "}
        {originName ?? "-"}{" "}
      </Typography>
      e destino
      <Typography component="span" sx={{fontWeight: 600}}>
        {" "}
        {destinationName ?? "-"}.
      </Typography>
      <br />
      <br />
      <Typography component="span" sx={{fontWeight: 600}}>
        As demais alterações não salvas do processo também serão PERDIDAS.
      </Typography>
    </Typography>
  );
};

export default AlertMessage;
